<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" @click.self="close">
      <div class="modal" :class="modalClass">
        <i class="btn-close" @click="close"></i>
        <header class="modal-header">
          <slot name="header" />
        </header>
        <section class="modal-body">
          <slot name="body" />
        </section>
        <footer class="modal-footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "VModal",
  props: {
    modalClass: String
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.modal-backdrop {
  position: fixed;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(2, 2, 2, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

.btn-close {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 10px;
  z-index: 1;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
